import axios from 'axios';

// const devUrl = 'http://localhost:3333/drupal';
const devUrl = 'http://calnew.app.movya.fi';
// const devUrl = 'https://calculus.paroc.com';
// const devUrl = "http://85.76.242.112"
let connectionProtocol;
if(window.location.protocol == 'http:') {
  connectionProtocol = 'http://';
} else {
  connectionProtocol = 'https://';
}
const prodUrl = connectionProtocol + window.location.hostname;

export const url = process.env.NODE_ENV === 'production' ? prodUrl : devUrl;

export const getToken = () => {
  return axios.get(url + '/session/token', {
    headers: {
      'Content-Type': 'application/vnd.api+json',
    },
    withCredentials: true,
  });
};


export const logIn = ({name = null, pass = null, ...items}) => {
  if(!name || !pass) return null;
  return axios.post(url + '/user/login?_format=json',
    {
      name: name,
      pass: pass
    }, {
      headers: {
          'Content-Type': 'application/vnd.api+json',
      },
      withCredentials: true
    }
  );
};

export const logOut = async () => {
  const token = sessionStorage.getItem('logoutToken');
  return axios.post(url + '/user/logout?_format=json&token=' + token,
    null, {
    headers: {
      'Content-Type': 'application/vnd.api+json',
      'credentials': 'include',
    }
  });
};

export const checkStatus = async () => {
  try {
    const token = await getToken();
    const status = await getStatus(token.data);

    if(status && status.data && status.data === 1) return true;
    return Promise.reject('Error not logged in');
  } catch (e) {
    return e;
  }
};

export const getMe = async () => {
  try {
    const me = await axios.get(
      url + '/user/me?_format=json',
      {
        headers: {
          'Content-Type': 'application/vnd.api+json',
        },
        withCredentials: true
      }
    );
console.log('ME:>>', me);
    if(me && me.data && me.data.length) return me.data[0];
    return Promise.reject('Error on user data');
  } catch (e) {
    return e;
  }
};

export const getStatus = (token) => {
  return axios.get(
    url + '/user/login_status?_format=json',
    {
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'X-CSRF-Token': token
      },
      withCredentials: true
    }
  );
};

export const getProjects = async (userid) => {
  const config = {
    headers: {
      'Content-Type': 'application/vnd.api+json',
    },
    withCredentials: true
  };

  let nextUrl = url + '/api/node/projects?filter[uid.id][value]=' + userid;
  let allData = [];
  let lastResponse = null;

  while (nextUrl) {
    const response = await axios.get(nextUrl, config);
    lastResponse = response;

    if (response.data && response.data.data) {
      allData = allData.concat(response.data.data);
    }

    const nextLink = response.data && response.data.links && response.data.links.next;
    nextUrl = nextLink && nextLink.href ? nextLink.href : null;
  }

  const links = { ...(lastResponse.data.links || {}) };
  delete links.next;

  return {
    ...lastResponse,
    data: {
      ...lastResponse.data,
      data: allData,
      links
    }
  };
};

export const createNewUserProject = async(data) => {
  const token = await getToken();

  return axios.post(
    url + '/api/node/projects',
    {
      'data': {
        'type': 'node--projects',
        'attributes': {
          'title': data.title,
          'data': JSON.stringify(data)
        }
      }
    },
    {
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'X-CSRF-Token': token && token.data ? token.data : ''
      },
      withCredentials: true
    }
  );
};

export const patchUserProject = async(data) => {
  const token = await getToken();

  console.log('PATCHING PROJECT:>>', data);

  const updatedData = {
    ...data,
  };
  delete updatedData.uuid;

  return axios.patch(
    url + '/api/node/projects/' + data.uuid,
    {
      'data': {
        'type': 'node--projects',
        'id': data.uuid,
        'attributes': {
          'title': data.title,
          'data': JSON.stringify(updatedData)
        }
      }
    },
    {
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'X-CSRF-Token': token && token.data ? token.data : ''
      },
      withCredentials: true,
    }
  );
};

export const deleteUserProject = async(id) => {
  const token = await getToken();

  return axios.delete(url + '/api/node/projects/' + id,
    {
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'X-CSRF-Token': token && token.data ? token.data : ''
      },
      withCredentials: true,
    }
  );
};

// Custom items
//
export const getCustoms = async (userid) => {
  const config = {
    headers: {
      'Content-Type': 'application/vnd.api+json',
    },
    withCredentials: true
  };

  let nextUrl = url + '/api/node/custom_items?filter[uid.id][value]=' + userid;
  let allData = [];
  let lastResponse = null;

  while (nextUrl) {
    const response = await axios.get(nextUrl, config);
    lastResponse = response;

    if (response.data && response.data.data) {
      allData = allData.concat(response.data.data);
    }

    const nextLink = response.data && response.data.links && response.data.links.next;
    nextUrl = nextLink && nextLink.href ? nextLink.href : null;
  }

  const links = { ...(lastResponse.data.links || {}) };
  delete links.next;

  return {
    ...lastResponse,
    data: {
      ...lastResponse.data,
      data: allData,
      links
    }
  };
};

export function createNewCustomItem(data, type, token) {
  return axios.post(
    url + '/api/node/custom_items',
    {
      'data': {
        'type': 'node--custom_items',
        'attributes': {
          'name': data.name,
          'data': JSON.stringify(data),
          'itemtype': type
        }
      }
    },
    {
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'X-CSRF-Token': token && token.data ? token.data : ''
      },
      withCredentials: true,
    }
  );
}

export const patchCustomItem = (data, type, token) => {
  console.log('PATCHING ITEM:>>', data);

  const updatedData = {
    ...data,
  };
  delete updatedData.uuid;
  delete updatedData.data;
  delete updatedData.drupal_internal__nid;

  return axios.patch(
    url + '/api/node/custom_items/' + data.uuid,
    {
      'data': {
        'type': 'node--custom_items',
        'id': data.uuid,
        'attributes': {
          'name': data.name,
          'data': JSON.stringify(updatedData),
        }
      }
    },
    {
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'X-CSRF-Token': token && token.data ? token.data : ''
      },
      withCredentials: true,
    }
  );
};

export const deleteCustomItem = (id, token) => {
  return axios.delete(url + '/api/node/custom_items/' + id,
    {
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'X-CSRF-Token': token && token.data ? token.data : ''
      },
      withCredentials: true,
    }
  );
};

export function patchSettings(data) {
  return new Promise(async function(resolve, reject) {
      let success = {
        create: [],
        patch: [],
        delete: [],
      };
      let errors = [];
      const token = await getToken();

      for(const item of data) {
        console.log('ITEM :::>', item);

        if(item.type === 'delete') {
          await deleteCustomItem(item.file.id, token).then(deletedItem => {
            success = {
              ...success,
              'delete': [
                ...success.delete,
                {
                  ...item.file
                }
              ]
            };
            console.log('delete success:>>', deletedItem);
          }).catch(err => {
            errors = [
              ...errors,
              err
            ];
            console.log('delete error:>>', err);
          });
        } else if(item.type === 'create') {
          await createNewCustomItem(item.file.item, item.file.type, token).then(item => {
            success = {
              ...success,
              'create': [
                ...success.create,
                {
                  ...item.data.data
                }
              ]
            };
            console.log('create success:>>', item);
          }).catch(err => {
            errors = [
              ...errors,
              err
            ];
            console.log('create error:>>', err);
          });
        } else if(item.type === 'patch') {
          await patchCustomItem(item.file.item, item.file.type, token).then(item => {
            success = {
              ...success,
              'patch': [
                ...success.patch,
                {
                  ...item.data.data
                }
              ]
            };
            console.log('patch success:>>', item);
          }).catch(err => {
            errors = [
              ...errors,
              err
            ];
            console.log('patch error:>>', err);
          });
        }
      }

      // if errors are 0 call resolve
      resolve({
        success,
        errors
      });
  });
}
